// TUTORIAL https://youtu.be/NoJa7FKqmhU?t=3558

import type { AgentTask, TaskExecution } from '~/server/agents/types'

interface TaskExecutionWithAgent extends TaskExecution {
  agent_task: AgentTask
}

interface AgentTasksState {
  tasks: TaskExecutionWithAgent[]
  isLoading: boolean
  error: string | null
}

interface SubscriptionState {
  subscription: any | null
  isLoading: boolean
  error: string | null
  hasActiveSubscription: boolean
}

export const useAuthChecked = () => useState<any>('authChecked', () => false)

export const useSupabaseUser = () => useState<any>('supabaseUser', () => null)

export const useSupabaseUserData = () => useState<any>('supbaseUserData', () => null)


export const useAdminSettings = () => useState<any>('adminSettings',  () => {
  return {
    showJSON: false
  }
})

export const useTicker = () => useState<any>('ticker', () => new Date().getTime())

export const useHasBeenIdentified = () => useState<boolean>('hasBeenIdentified', () => { return false })

export const useCompanyData = () => useState<any>("companyData", () => {
  null
})

export const useAppVersionStatus = () => useState<string>('appVersionStatus', () => {
  return 'matched'
})

export const useIsMobile = () => useState<boolean>('isMobile', () => {
  return true
})

export const useCompanyCompetitors = () => useState<any>('companyCompetitors', () => {
  return {
    competitors: [],
    isLoading: true,
    error: null
  }
})

export const useColorScheme = () => useState<string>('colorScheme', () => {
  return 'myLight'
})

export const useAgentTasks = () => useState<AgentTasksState>('agentTasks', () => {
  return {
    tasks: [],
    isLoading: true,
    error: null
  }
})

export const useSubscribedChannels = () => useState<any>('subscribedChannels', () => {
  return {
    channels: {}
  }
})

export const useSubscriptionState = () => useState<SubscriptionState>('subscriptionState', () => {
  return {
    subscription: null,
    isLoading: false,
    error: null,
    hasActiveSubscription: false
  }
})